// extracted by mini-css-extract-plugin
export default {"close":"custom-close_close__l4n1B"};